import React, { Component } from "react";
import { getValue } from "../../utils";

class Color extends Component {
  render() {
    const color = getValue(this.props) || [];

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          fontSize: "14px",
          width: "20px",
          height: "20px",
          border: "1px solid #ddd",
          borderRadius: "3px",
          backgroundColor: color
        }}
      ></div>
    );
  }
}

export default Color;
